module.exports = __webpack_public_path__ + "img/epg_migration_logo.9bd927e4.png";